import { AppButton, Icon, type IconName } from '@core/designsystem';
import { STATS_TEXT, STORAGE_WARNING } from './formatter';
import './settings.css';

/**
 * Первый запуск — «Структура» §15.
 *
 * Четыре мысли и одна кнопка. Обучения здесь нет и быть не должно: приложение, которое
 * нужно объяснять, юрист закроет раньше, чем дочитает. Единственное, что обязано быть
 * сказано, — где живут данные и что с ними станет.
 */
export function OnboardingScreen({ onStart }: { onStart: () => void }) {
  return (
    <div className="onboarding">
      <h1 className="onboarding__title">Все ваши дела в телефоне.</h1>
      <p className="onboarding__lead">
        Клиенты, документы и сроки в одном месте. Работает без интернета.
      </p>

      <Point
        icon="folder"
        title="Дело как рабочее место"
        text="Документы, задачи, заседания и клиент внутри дела. Не в галерее, файлах и переписке."
      />
      <Point
        icon="check"
        title="Работает без сети"
        text="Приложению не нужен интернет: ни одна функция не зависит от связи."
      />
      <Point icon="error" title="Данные только на этом устройстве" text={STORAGE_WARNING} warning />
      <Point icon="settings" title="Обезличенная статистика" text={STATS_TEXT} />

      <AppButton onClick={onStart}>Создать первое дело</AppButton>
    </div>
  );
}

function Point({
  icon,
  title,
  text,
  warning = false,
}: {
  icon: IconName;
  title: string;
  text: string;
  warning?: boolean;
}) {
  return (
    <div className="onboarding__point">
      <Icon
        name={icon}
        size={24}
        className={`onboarding__point-icon ${warning ? 'onboarding__point-icon--warning' : ''}`}
      />
      <div>
        <h2 className="onboarding__point-title">{title}</h2>
        <p className="onboarding__point-text">{text}</p>
      </div>
    </div>
  );
}
